import { OfferSubCategory } from '../../../common/enums.js';
import { t } from '../../../common/i18n/index.js';
import { AccessoryProductConfigCoCo } from './accessory/AccessoryProductConfigCoCo.js';
import { DeviceProductConfigCoCo } from './device/DeviceProductConfigCoCo.js';
import { FixedBroadbandProductConfigCoCo } from './fixedBroadband/FixedBroadbandProductConfigCoCo.js';
import { FixedMobileBroadbandProductConfigCoCo } from './fixedBroadband/FixedMobileBroadbandProductConfigCoCo.js';
import { renderMobileAddonContent } from './mobileOffering/MobileAddonContentCoCo.js';
import { MobileOfferingConfigCoCo } from './mobileOffering/MobileOfferingConfigCoCo.js';
import { registerProductConfig } from './productConfigRegistryCoCo.js';
import { type ForwardRefConfigComponent, ProductConfigScope } from './productConfigTypesCoCo.js';
import { SoftwareProductConfigCoCo } from './software/SoftwareProductConfigCoCo';

registerProductConfig(OfferSubCategory.MOBILE_VOICE, {
  component: MobileOfferingConfigCoCo as ForwardRefConfigComponent,
  renderAddonContent: renderMobileAddonContent,
});

registerProductConfig(OfferSubCategory.MOBILE_BROADBAND, {
  component: MobileOfferingConfigCoCo as ForwardRefConfigComponent,
  renderAddonContent: renderMobileAddonContent,
});

registerProductConfig(OfferSubCategory.FIXED_BROADBAND, {
  component: FixedBroadbandProductConfigCoCo as ForwardRefConfigComponent,
  supportsInstallationAvailability: true,
  configScope: ProductConfigScope.PRODUCT,
});

registerProductConfig(OfferSubCategory.FIXED_BB_CABLE_MODEM, {
  component: FixedBroadbandProductConfigCoCo as ForwardRefConfigComponent,
  supportsInstallationAvailability: true,
  configScope: ProductConfigScope.PRODUCT,
});

registerProductConfig(OfferSubCategory.FIXED_MOBILE_BROADBAND, {
  component: FixedMobileBroadbandProductConfigCoCo as ForwardRefConfigComponent,
  supportsInstallationAvailability: true,
  configScope: ProductConfigScope.PRODUCT,
});
registerProductConfig(OfferSubCategory.SOFTWARE, {
  component: SoftwareProductConfigCoCo as ForwardRefConfigComponent,
});

registerProductConfig(OfferSubCategory.DEVICE_POT, {
  component: DeviceProductConfigCoCo as ForwardRefConfigComponent,
  alwaysCollectPurposeOfUse: true,
});

registerProductConfig(OfferSubCategory.EPP_DEVICE_POT, {
  component: DeviceProductConfigCoCo as ForwardRefConfigComponent,
});

registerProductConfig(OfferSubCategory.QUANTITY_BASED_ACCESSORY, {
  component: AccessoryProductConfigCoCo as ForwardRefConfigComponent,
  alwaysCollectPurposeOfUse: true,
  // Accessories are ordered by quantity and configured once for the whole quantity.
  configScope: ProductConfigScope.PRODUCT,
  getSectionHeading: () => t.B4ZV('Product details'),
});
